import { State, IEntity, IStateConfig } from '../common/engine/state';
import { ISystemConstructor } from '../common/engine/system';
import { Asset } from '../common/engine/asset';
import { Socket } from '../common/engine/socket';

export interface IGameConfig extends IStateConfig {
    game?: string;
}

Asset.initialize(Socket.on, fetch);
export const Run = (config: IGameConfig) => {
    const state = new State(config);

    if(config.game) {
        Asset.watch(config.game, (gameData: IEntity) => {
            state.loadGame(gameData);
        });
    }
};



// WEBPACK FOOTER //
// ./src/client/index.ts